import { Button, Form, Input, Select, message } from "antd";
import axios from "axios";
import { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
// import { GlobalContext } from "../../../../context/GlobalContext";

export const Formulario = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values) => {
    const { fullName, phoneNumber, orgName, email, product, referrer } = values;

    if (!fullName?.trim()) {
      return messageApi.info("Es necesario un nombre");
    }

    if (!phoneNumber?.trim() && !email?.trim()) {
      return messageApi.info("Es necesario un dato de contacto");
    }

    let text = `Nueva solicitud de demo. \n
      Nombre: ${fullName}, \n
      Organización: ${orgName}, \n
      Teléfono: ${phoneNumber}, \n
      email: ${email}. \n

      Está interesado en: ${product}.
    `;

    if (referrer) {
      text += `\n
      Conoció binamics por: ${referrer}`;
    }

    setLoading(true);

    const config = {
      url: `https://api2.brocoly.ar/api/binamics/sendEmail`,
      method: "post",
      data: {
        emailType: "Solicitud de demo",
        emailText: text,
      },
    };

    try {
      const { data } = await axios(config);

      messageApi.success(
        "Solicitud enviada. ¡Nos contactaremos a la brevedad!"
      );
    } catch (error) {
      console.error(error);
      alert(
        error?.response?.data?.message ||
          "Ocurrió un error al enviar la solicitud."
      );
      messageApi.error(
        error?.response?.data?.message ||
          "Ocurrió un error al enviar la solicitud."
      );
    } finally {
      setLoading(false);
    }
    // createNewDemo(values)
    //   .then((res) => {
    //     if (res?.status === 200) {
    //       // messageApi.success(
    //       //   "Solicitud cargada correctamente. ¡Nos contactaremos a la brevedad!"
    //       // );

    //       form.resetFields();
    //     }
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //     // messageApi.error(
    //     //   error?.response?.data?.message ||
    //     //     "Ocurrió un error al crear solicitud de demo"
    //     // );
    //   })
    //   .finally(() => setLoading(false));
  };

  return (
    <section className="formulario-section" id="form">
      {contextHolder}
      <Form
        form={form}
        onFinish={onFinish}
        className="landing-form"
        id="contacto-form"
        layout="vertical"
      >
        <p className="formulario-title" style={{ gridColumn: "1 / -1" }}>
          SOLICITAR DEMO PERSONALIZADA
        </p>

        <Form.Item
          className="landing-form-item"
          name="fullName"
          label="¿Cómo te llamas? *"
        >
          <Input variant="borderless" className="landing-form-input" />
        </Form.Item>

        <Form.Item
          className="landing-form-item"
          name="orgName"
          label="Empresa *"
        >
          <Input variant="borderless" className="landing-form-input" />
        </Form.Item>

        <Form.Item
          className="landing-form-item"
          name="email"
          label="Correo electrónico *"
        >
          <Input variant="borderless" className="landing-form-input" />
        </Form.Item>

        <Form.Item
          className="landing-form-item"
          name="phoneNumber"
          label="Celular *"
        >
          <Input variant="borderless" className="landing-form-input" />
        </Form.Item>

        <Form.Item
          className="landing-form-item"
          name="referrer"
          label="¿Cómo te enteraste de Binamics?"
        >
          <Input variant="borderless" className="landing-form-input" />
        </Form.Item>

        <Form.Item
          className="landing-form-item"
          name="product"
          label="¿Qué producto te interesa?"
        >
          <Select
            className="landing-form-input"
            variant="borderless"
            options={[
              {
                label: "Inteligencia de negocios",
                value: "Inteligencia de negocios",
              },
              {
                label: "Inteligencia de clientes",
                value: "Inteligencia de clientes",
              },
              { label: "Ambos", value: "Ambos productos" },
            ]}
          />
        </Form.Item>

        <Button
          htmlType="submit"
          type="secondary"
          className="boton-generico boton-blanco"
          style={{ height: "3rem" }}
          loading={loading}
        >
          <p>Enviar</p>
          <FaArrowRight />
        </Button>
      </Form>
    </section>
  );
};
